export default "__VITE_ASSET__BOBfgnyw__"